import type { IntlShape } from 'react-intl'

import { DEFAULT_LOCALE, LOCALES } from '../utils/i18n'

export const getSliteWebsiteConfig = (intl: IntlShape) => ({
  domain: 'https://slite.com',
  siteName: 'Slite',
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  favicons: {
    ico: 'https://storage.googleapis.com/slite-cdn/slite-assets/favicon.ico?v=2',
    png16:
      'https://storage.googleapis.com/slite-cdn/slite-assets/favicon-16x16.png?v=2',
    png32:
      'https://storage.googleapis.com/slite-cdn/slite-assets/favicon-32x32.png?v=2',
    appleTouchIcon:
      'https://storage.googleapis.com/slite-cdn/slite-assets/apple-touch-icon.png?v=2',
  },
  defaultTitle: intl.formatMessage({
    id: 'slite.homepage.helmet.title',
    defaultMessage: 'Slite | The AI knowledge base that stays accurate',
  }),
  defaultDescription: intl.formatMessage({
    id: 'slite.homepage.helmet.description',
    defaultMessage:
      'Slite connects to the tools where work happens to build and maintain the knowledge your business depends on, so your team and their AI can work from reliable answers.',
  }),
  defaultOGImage:
    'https://cdn.sanity.io/images/dnsgqii5/production/0f4063a9ce14a132541202bb500bc56b97c1578c-2400x1260.jpg',
})
